import { createContext, useContext } from "react";
import type { ChatbotCreateEvent } from "../schema";

export type TriggerChatbotBlockActionHandler = (
  event: ChatbotCreateEvent,
  notificationMessage?: string
) => Promise<void>;

export const BotActionsContext =
  createContext<TriggerChatbotBlockActionHandler>(
    async function notImplemented() {
      throw new Error("Not implemented");
    }
  );

export function useTriggerChatbotBlockAction() {
  const context = useContext(BotActionsContext);
  if (!context) {
    throw new Error(
      "useTriggerChatbotBlockAction must be used within a BotActionsContext"
    );
  }
  return context;
}
